import * as z from "zod";

const PLAN_CUSTOM_ANALYTICS_REPORT_TOOL_NAME = "plan-custom-analytics-report";
const PLAN_CUSTOM_ANALYTICS_REPORT_EDIT_TOOL_NAME =
  "plan-custom-analytics-report-edit";
const CREATE_CUSTOM_ANALYTICS_REPORT_TOOL_NAME =
  "create-custom-analytics-report";
const EDIT_CUSTOM_ANALYTICS_REPORT_TOOL_NAME = "edit-custom-analytics-report";

const ReadyForConfirmationOutputSchema = z
  .object({ status: z.literal("ready_for_confirmation") })
  .passthrough();

const PreparingReportOutputSchema = z
  .object({
    status: z.literal("preparing"),
    customReportUrl: z.string().min(1),
  })
  .passthrough();

export type CustomAnalyticsReportAction =
  | {
      type: "confirm";
      operation: "create" | "edit";
      label: string;
      message: string;
    }
  | { type: "view-report"; url: string };

export function tryParseCustomAnalyticsReportAction(
  toolName: string,
  output: unknown,
): CustomAnalyticsReportAction | null {
  if (
    toolName === PLAN_CUSTOM_ANALYTICS_REPORT_TOOL_NAME &&
    ReadyForConfirmationOutputSchema.safeParse(output).success
  ) {
    return {
      type: "confirm",
      operation: "create",
      label: "Confirm and generate",
      message: "Yes, create it.",
    };
  }

  if (
    toolName === PLAN_CUSTOM_ANALYTICS_REPORT_EDIT_TOOL_NAME &&
    ReadyForConfirmationOutputSchema.safeParse(output).success
  ) {
    return {
      type: "confirm",
      operation: "edit",
      label: "Confirm and update",
      message: "Yes, update it.",
    };
  }

  if (
    toolName === CREATE_CUSTOM_ANALYTICS_REPORT_TOOL_NAME ||
    toolName === EDIT_CUSTOM_ANALYTICS_REPORT_TOOL_NAME
  ) {
    const result = PreparingReportOutputSchema.safeParse(output);
    if (result.success) {
      return { type: "view-report", url: result.data.customReportUrl };
    }
  }

  return null;
}
